import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { Theme, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .title {
    font-family: ${font.saolText};
  }
`;

export const SliderWrapper = styled.div<{ theme: Theme }>`
  .slick-track {
    .slick-slide {
      padding-right: 20px;
    }
  }

  .slick-slider {
    .slick-prev,
    .slick-next {
      &.slick-disabled {
        border-color: ${getColor('neutralLightGray3')};
      }
    }

    @media (${breakpoint.xlMin}) {
      .slick-next {
        right: -15px;
      }

      .slick-prev {
        left: -35px;
      }
    }
  }
`;
